import { useEffect, useState } from "react";
import { api, inr } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow
} from "@/components/ui/table";

export default function AdminPayments() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/payments").then((r) => setRows(r.data)); }, []);
  return (
    <div className="space-y-6" data-testid="admin-payments">
      <div>
        <h1 className="font-heading text-3xl font-bold tracking-tight">Payments</h1>
        <p className="text-sm text-muted-foreground mt-1">All subscription payments across TheBillPro</p>
      </div>
      <Card className="overflow-hidden">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Date</TableHead>
              <TableHead>Business</TableHead>
              <TableHead>Order ID</TableHead>
              <TableHead>Plan</TableHead>
              <TableHead>Amount</TableHead>
              <TableHead>Status</TableHead>
              <TableHead>Payment ID</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map((p) => (
              <TableRow key={p.id}>
                <TableCell className="text-xs">{(p.created_at || "").slice(0, 10)}</TableCell>
                <TableCell className="font-medium">{p.company_name}</TableCell>
                <TableCell className="font-mono text-xs">{p.order_id}</TableCell>
                <TableCell>{p.plan_code}</TableCell>
                <TableCell>{inr(p.amount)}</TableCell>
                <TableCell>
                  <Badge variant={p.status === "successful" ? "default" : p.status === "failed" ? "destructive" : "secondary"}>{p.status}</Badge>
                </TableCell>
                <TableCell className="font-mono text-xs">{p.payment_id || "—"}</TableCell>
              </TableRow>
            ))}
            {rows.length === 0 && (
              <TableRow><TableCell colSpan={7} className="text-center text-sm text-muted-foreground py-8">No payments yet.</TableCell></TableRow>
            )}
          </TableBody>
        </Table>
      </Card>
    </div>
  );
}
